/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_AiInputs */

const en_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable AI`)
};

const es_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar IA`)
};

const fr_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer l'IA`)
};

const de_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI aktivieren`)
};

const ja_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIを有効にする`)
};

const zh_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用 AI`)
};

const ar_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفعيل الذكاء الاصطناعي`)
};

const id_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan AI`)
};

const it_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita IA`)
};

const ru_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить ИИ`)
};

const pt_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar IA`)
};

const ko_enable_ai = /** @type {(inputs: Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 활성화`)
};

/**
* | output |
* | --- |
* | "Enable AI" |
*
* @param {Enable_AiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enable_ai = /** @type {((inputs?: Enable_AiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_AiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enable_ai(inputs)
	if (locale === "es") return es_enable_ai(inputs)
	if (locale === "fr") return fr_enable_ai(inputs)
	if (locale === "de") return de_enable_ai(inputs)
	if (locale === "ja") return ja_enable_ai(inputs)
	if (locale === "zh") return zh_enable_ai(inputs)
	if (locale === "ar") return ar_enable_ai(inputs)
	if (locale === "id") return id_enable_ai(inputs)
	if (locale === "it") return it_enable_ai(inputs)
	if (locale === "ru") return ru_enable_ai(inputs)
	if (locale === "pt") return pt_enable_ai(inputs)
	return ko_enable_ai(inputs)
});